import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../HandleHttpErrors";
import GetParsedDate from "../shared/GetParsedDate";
import { useMoamadContext } from "../shared/context/MoamadContext";
import MyJustDate from "../shared/MyJustDate";
const baseURL = process.env.REACT_APP_API;

const MoamadRep = ({ proposalStatus }) => {
  // State for the selected year
  const [userName, setUserName] = useState("");
  const { moamadRep, updateMoamadRep } = useMoamadContext();
  const axiosPrivate = useAxiosPrivate("application/json");
  const now = MyJustDate(new Date());
  let history = useNavigate();
  useEffect(() => {
    document.body.classList.add("accountBodyColor");
    // Clean up function to remove the class when the component unmounts
    return () => {
      document.body.classList.remove("accountBodyColor");
    };
  }, []);

  const getMoamadRep = async () => {
    //const [moamads, setMoamads] = [];
    let isMounted = true;
    const controller = new AbortController();
    const getMoamadeem = async () => {
      try {
        const response = await axiosPrivate.get(
          baseURL + "jobs/moamadrep/?username=" + userName,
          {
            signal: controller.signal,
          },
        );
        if (isMounted) {
          updateMoamadRep(response.data.sort((a, b) => b.id - a.id));
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left",
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    getMoamadeem();
    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  };

  const handleClickButton = (event) => {
    getMoamadRep();
    // You can fetch data based on the selected year here
  };
  const handleTdClick = (moamadId, mekhrazTitle) => {
    // Construct the URL based on your route
    const url = `/moamad/${moamadId}/${mekhrazTitle}`;

    // Use history.push to navigate to the MoamadAdmin component
    history(url);
  };

  return (
    <div>
      {/* First line: Dropdown to select a year */}
      <br />
      <h2 style={{ textAlign: "center", color: "white" }}>
        ההצעות של המועמד{" "}
        {moamadRep
          ? moamadRep.length > 0
            ? moamadRep[0].user__username
            : ""
          : ""}
      </h2>

      <form>
        <div style={{ textAlign: "center" }}>
          <label
            style={{
              color: "black",
              fontSize: "20px",
              fontWeight: "bold",
              marginLeft: "10px",
            }}
          >
            שם משתמש/ת"ז
          </label>
          <input
            type="text"
            name="userName"
            value={userName}
            onChange={(e) => setUserName(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault(); // Prevent the default behavior of the Enter key
                handleClickButton(); // Call your custom function
              }
            }}
            className="form-control"
            id="userName"
            placeholder=""
          />
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleClickButton}
          >
            חפש
          </button>
        </div>
      </form>
      <div style={{ marginTop: "20px", backgroundColor: "rgb(200, 200, 200)" }}>
        <center>
          {" "}
          <h2>ההגשות של המשתמש</h2>
        </center>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "black",
            fontWeight: "bold",
          }}
        >
          <table>
            <thead>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <th
                  className="padding10-td"
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "20px",
                  }}
                >
                  מזהה
                </th>
                <th
                  className="padding10-td"
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "20px",
                    textAlign: "center",
                  }}
                >
                  שם מלא
                </th>

                <th
                  className="padding10-td"
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "20px",
                  }}
                >
                  מס' מכרז
                </th>
                <th
                  className="padding10-td"
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "20px",
                  }}
                >
                  תאור המכרז
                </th>
                <th
                  className="padding10-td"
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "20px",
                  }}
                >
                  תאריך יצירה
                </th>
                <th
                  className="padding10-td"
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "20px",
                  }}
                >
                  תאריך הגשה
                </th>
                <th
                  className="padding10-td"
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "20px",
                  }}
                >
                  תנאי הסף
                </th>
              </tr>
            </thead>
            <tbody>
              {moamadRep?.map((item, index) => {
                const isDisabled =
                  proposalStatus === "חסויה" &&
                  MyJustDate(new Date(item.mekhraz__hagsha_date)) >= now;
                const isDisabledDocument =
                  proposalStatus === "מסמכים חסויים" &&
                  MyJustDate(new Date(item.mekhraz__hagsha_date)) >= now;
                return (
                  <tr style={{ borderBottom: "1px solid #ddd" }} key={index}>
                    <td
                      isDisabled={isDisabled}
                      className="changetextsize-td"
                      style={{
                        textAlign: "center",
                        cursor: isDisabled ? "not-allowed" : "pointer",
                        color: isDisabled ? "gray" : "blue",
                        textDecoration: isDisabled ? "none" : "underline",
                      }}
                      onClick={() => {
                        if (!isDisabled) {
                          history("/moamadadmin", {
                            state: {
                              moamad_id: item.id,
                              user_id: item.user,
                              mekhraz_title: item.mekhraz__title,
                              is_disabled_doc: isDisabledDocument,
                            },
                          });
                        }
                      }}
                    >
                      {item.id}
                    </td>

                    <td
                      className="padding10-td"
                      style={{ textAlign: "center" }}
                    >
                      {item.f_name +
                        " " +
                        (item.father_name ? item.father_name + " " : "") +
                        " " +
                        item.l_name}
                    </td>

                    <td
                      className="padding10-td"
                      style={{ textAlign: "center" }}
                    >
                      {item.mekhraz__mkh_num}
                    </td>
                    <td
                      className="padding10-td"
                      style={{ textAlign: "center" }}
                    >
                      {item.mekhraz__title}
                    </td>
                    <td
                      className="padding10-td"
                      style={{ textAlign: "center" }}
                    >
                      <GetParsedDate
                        strDate={item.created_date}
                        withTime={false}
                      />{" "}
                    </td>
                    <td
                      className="padding10-td"
                      style={{ textAlign: "center" }}
                    >
                      {item.signature_date ? (
                        <GetParsedDate
                          strDate={item.signature_date} // Remove comma using regular expression
                          withTime={false}
                        />
                      ) : (
                        "לא הוגשה"
                      )}
                    </td>

                    <td
                      className="padding10-td"
                      style={{ textAlign: "center" }}
                    >
                      {item.saf ? "כן" : "לא"}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>

          <div>
            <br />
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "black",
            fontWeight: "bold",
          }}
        >
          {moamadRep?.length === 0 && (
            <p
              style={{
                color: "blue",
                fontWeight: "bold",
                fontSize: "20px",
                textDecoration: "underline",
              }}
            >
              לא קיימות הצעות למועמד{" "}
            </p>
          )}
        </div>
      </div>
      <br />
    </div>
  );
};

export default MoamadRep;
